/* Version: 3.5.137 */
'use client';
import { useContext } from 'react';
import { AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';
import i18n from '../../lang/i18n/index.js';
import Element from '../../utils/Element.js';
import handle from '../../utils/handle.js';
import HeaderTabs from './shared/HeaderTabs.js';
import SideNavContext from './SideNavContext.js';
import { MobileMainNavWrapper, MobileHeaderItem, MainNavList, MobileFooterWrapper, MobileFooterItem } from './styledComponents.js';
import { renderSelectedTabContent } from './utils.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import useLang from '../../hooks/useLang.js';
import useTheme from '../../hooks/useTheme.js';
import useNavigation from '../../hooks/useNavigation.js';

var MobileMenu = function MobileMenu(_ref) {
  var children = _ref.children,
    mainNavRef = _ref.mainNavRef;
  var _useContext = useContext(SideNavContext),
    keepOpenOnSelect = _useContext.keepOpenOnSelect,
    isMobileNavExpanded = _useContext.isMobileNavExpanded,
    setMobileNavExpanded = _useContext.setMobileNavExpanded,
    mobileTabs = _useContext.mobileTabs,
    onChangeMobileTabs = _useContext.onChangeMobileTabs,
    mobileSelectedTab = _useContext.mobileSelectedTab,
    mobileHeaderItems = _useContext.mobileHeaderItems,
    mobileFooterItems = _useContext.mobileFooterItems,
    selectedTab = _useContext.selectedTab,
    setSelectedTab = _useContext.setSelectedTab;
  var lang = useLang();
  var theme = useTheme();
  var _useNavigation = useNavigation(),
    isSignedIn = _useNavigation.isSignedIn;
  var renderTabs = function renderTabs(Wrapper // NOSONAR
  ) {
    return !isSignedIn && mobileTabs.length > 0 && /*#__PURE__*/jsx(Wrapper, {
      theme: theme,
      children: /*#__PURE__*/jsx(HeaderTabs, {
        tabs: mobileTabs,
        selectedTab: mobileSelectedTab,
        onChange: function onChange(selected, e) {
          setSelectedTab(selected);
          if (!keepOpenOnSelect) {
            setMobileNavExpanded(false);
          }
          return handle(onChangeMobileTabs)(e, selected);
        }
      })
    });
  };
  return /*#__PURE__*/jsx(AnimatePresence, {
    children: isMobileNavExpanded && /*#__PURE__*/jsxs(MobileMainNavWrapper, {
      initial: {
        x: '100%'
      },
      animate: {
        x: 0
      },
      exit: {
        x: '100%'
      },
      transition: {
        ease: 'easeInOut',
        duration: 0.4
      },
      theme: theme,
      children: [theme.sideNav.mobile.header.showTabs && renderTabs(MobileHeaderItem), mobileHeaderItems === null || mobileHeaderItems === undefined ? undefined : mobileHeaderItems.map(function (item, i) {
        return item && /*#__PURE__*/jsx(MobileHeaderItem, {
          "data-testid": "header-".concat(i),
          theme: theme,
          children: item
        }, "header-".concat(item.key));
      }), children && /*#__PURE__*/jsx(MainNavList, {
        theme: theme,
        children: renderSelectedTabContent(mobileTabs, selectedTab, children, mainNavRef)
      }), theme.sideNav.mobile.footer.showTabs && renderTabs(MobileFooterItem), /*#__PURE__*/jsx("nav", {
        "aria-label": i18n[lang].sideNav.mobileFooterSection,
        children: /*#__PURE__*/jsx(MobileFooterWrapper, {
          children: mobileFooterItems === null || mobileFooterItems === undefined ? undefined : mobileFooterItems.map(function (item, i) {
            return item && /*#__PURE__*/jsx(MobileFooterItem, {
              "data-testid": "footer-".concat(i),
              theme: theme,
              children: item
            }, "footer-".concat(item.key));
          })
        })
      })]
    }, "mobile-nav-wrapper")
  });
};
process.env.NODE_ENV !== "production" ? MobileMenu.propTypes = {
  children: PropTypes.node,
  /** Ref of the first main nav item */
  mainNavRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })])
} : undefined;
process.env.NODE_ENV !== "production" ? MobileMenu.displayName = 'MobileMenu' : undefined;

export { MobileMenu as default };
